export const FREE_UPLOAD_LIMIT_BYTES = 50 * 1024 * 1024;

// Premium is advertised as 3 GB. The small internal buffer prevents files
// reported by operating systems as 3 GB from being rejected due to rounding.
export const PREMIUM_UPLOAD_LIMIT_BYTES = 3_100_000_000;

export const uploadLimitBytes = (isPremium) => (
  isPremium ? PREMIUM_UPLOAD_LIMIT_BYTES : FREE_UPLOAD_LIMIT_BYTES
);

export const uploadLimitLabel = (isPremium) => (isPremium ? "3 GB" : "50 MB");

export const fileExceedsUploadLimit = (file, isPremium) => (
  Boolean(file) && Number(file.size) > uploadLimitBytes(isPremium)
);
